export interface ShippingTypeConfig {
  label: string
  needAddress: boolean
  isSlotBased: boolean
}

export const SHIPPING_TYPES: Record<string, ShippingTypeConfig> = {
  pickup: {
    label: 'Экспресс',
    needAddress: false,
    isSlotBased: false
  },
  // partner: {
  //   label: 'Своя',
  //   needAddress: true
  // },
  our: {
    label: 'В слот',
    needAddress: true,
    isSlotBased: true
  }
}
